import { strip_empty_label_plugin } from "./Strip_empty_label_plugin";

export const optionsWindDir = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      type: "time",
      title: {
        display: true,
        text: "Tijd",
      },
      distribution: "linear",
      bounds: "data",
      time: {
        // min: 1652997600000,
        // max: 1653084000000,
        displayFormats: {
          hour: "H:mm",
          minute: "H:mm",
        },
        tooltipFormat: "H:mm",
      },
      ticks: {
        beginAtZero: false,
        maxRotation: 0,
      },
    },
    y: {
      suggestedMin: 0,
      suggestedMax: 360,

      distribution: "linear",
      title: {
        display: true,
        text: "Windrichting (graden)",
      },
      ticks: {
        stepSize: 45,
      },
    },
  },

  plugins: {
    title: {
      text: "TODO Make this title dynamic",
      display: true,
    },
    legend: {
      display: true,
      labels: {
        generateLabels: strip_empty_label_plugin,
      },
    },
    tooltip: {
      enabled: true,
      axis: "xy",
      mode: "x",
      intersect: false,
      callbacks: {
        //label: labelCallback("graden"),
      },
    },
  },
};
